import React from "react";
import i18n from "../../../../constants/i18n";
import { DEVELOPER_FEATURES_HEADERS } from "../../../../constants/table-custom-headers/Developers";
import { KHATTABAT_AVAILABILITY } from "../../../../constants/table-custom-headers/Khattabat";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getSupervisorKhattabatStore from "../../../../stores/supervisor-store/supervisor-khattabat-store";

const Data = withLiteObserverAndTheme(() => {
  const khattabatFeatures =
    getSupervisorKhattabatStore().khattabatFeatures.get();

  const khattabatAvailability =
    getSupervisorKhattabatStore().khattabatAvailability.get();
  return (
    <React.Fragment>
      <Et3Table
        columns={DEVELOPER_FEATURES_HEADERS}
        rows={khattabatFeatures}
        title={i18n.get("FEATURES")}
        shouldBeFlagged={false}
        titleKey={"FEATURES"}
      />
      <Et3Margin top={15} bottom={15} left={0} right={0} />
      <Et3Table
        columns={KHATTABAT_AVAILABILITY}
        rows={khattabatAvailability}
        title={i18n.get("KHATTABAT_CAPACITY")}
        shouldBeFlagged={false}
        titleKey={"KHATTABAT_CAPACITY"}
      />
    </React.Fragment>
  );
});

export default Data;
